export default "<a (click)=\"openRewards()\" class=\"gift-button\">\n    <img alt=\"\" src=\"assets/images/icons/icon_gift_white.svg\">\n</a>";